import React, { useCallback, useContext, useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { BsArrowDown } from "react-icons/bs";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import ButtonPermission from "../../../components/UI/Button/ButtonPermission";
import funcionalidades from "../../../context/AuthContext.funcionalidades";
import TextSpinner from "../../../components/UI/Spinner/TextSpinner";
import { formatarData } from "../../../components/Formatters/DateTime";
import AlteracaoExecutorOsDetalhes from "./components/AlteracaoExecutorOsDetalhes";
import TelaAlteraExecutorOs from "./components/TelaAlteraExecutorOs";
import { AuthContext } from "../../../context/AuthContext";
import useResponsabilidadeOrgao from "../ExecutarOrdemServico/hooks/useResponsabilidadeOrgao";
import OsContext from "../../../context/OsContext";
import CustomExpanderIcon from "../../../components/UI/DataTable/CustomExpanderIcon";
import constants from "../../Constants";

const columns = [
  {
    width: "55px",
    selector: (row) => <CustomExpanderIcon row={row} emptyWhen={(item) => (item.anexos?.length ?? 0) === 0} />,
  },
  {
    name: "Nº Alteração",
    selector: "sqAlteracaoExecutor",
    center: true,
    sortable: true,
  },
  {
    name: "Data Geração",
    cell: (row) => (row.dataInclusao ? formatarData(row.dataInclusao, "dd/MM/yyyy") : null),
    center: true,
    sortable: true,
  },
  {
    name: "Usuário",
    selector: "nomeFormal",
    center: true,
    sortable: true,
  },
  {
    name: "Situação",
    selector: "situacaoAlteracao",
    center: true,
    sortable: true,
  },
];

const AlteracaoExecutorOs = ({ dadosOs, history }) => {
  const usuario = JSON.parse(localStorage.getItem("user"));
  const [rows, setRows] = useState([]);
  const [totalRows] = useState(0);
  const setPageSize = useState(25)[1];
  const setPageNumber = useState(1)[1];
  const { request: requestConsulta, data: dataConsulta, errors: errorConsulta, isLoading } = useApiClient();
  const [mostrarTela, setMostrarTela] = useState(false);
  const [dadosAltExec, setDadosAltExec] = useState([]);
  const [atualizaAlteracao, setAtualizaAlteracao] = useState({});

  const atualizarAlteracao = (novaAtualizacao) => {
    setAtualizaAlteracao(novaAtualizacao);
  };
  const { user } = useContext(AuthContext);
  const [caminhoHistory, setCaminhoHistory] = useState({});
  const { responsabilidadeOrgao } = useResponsabilidadeOrgao(user.codigo);
  const [limpaTela, setLimpaTela] = useState();

  const limparTela = (limpar) => {
    setLimpaTela(limpar);
  };

  const handlePageChange = useCallback(
    (newPageNumber) => {
      setPageNumber(newPageNumber);
    },
    [setPageNumber],
  );

  const handlePerRowsChange = useCallback(
    (newPageSize) => {
      setPageSize(newPageSize);
      setPageNumber(1);
    },
    [setPageNumber, setPageSize],
  );

  useEffect(() => {
    if (dadosOs || atualizaAlteracao || limpaTela) {
      const params = { sqOrdemServico: dadosOs.sequencial };
      requestConsulta(apiRoutes.fiscalizacao.alteracaoexecutor.consultaAlteracaoExecutores, params);
    }
  }, [requestConsulta, dadosOs.sequencial, dadosOs, atualizaAlteracao, limpaTela]);

  useEffect(() => {
    if (dataConsulta && dataConsulta.result) {
      setRows(dataConsulta.result.map((item) => ({ ...item, dadosOs })));
      setDadosAltExec(dataConsulta.result);
    }

    if (errorConsulta) {
      toast.error(errorConsulta.message);
    }
  }, [dataConsulta, errorConsulta, dadosOs]);

  useEffect(() => {
    setCaminhoHistory({ ...history });
  }, [history]);

  const { location } = history;
  const { pathname } = location;

  const caminho = pathname === "/app/os/consultarOs/consulta";

  return (
    <OsContext.Provider value={caminhoHistory}>
      <div style={{ width: "100%" }}>
        {!mostrarTela &&
          dadosAltExec[0]?.situacaoAlteracaoAtual !== "A" &&
          (responsabilidadeOrgao === "C" || responsabilidadeOrgao === "S") &&
          !caminho &&
          dadosOs.cdDiretorAtribuido === usuario.codigo && (
            <Row style={{ marginBottom: 20, textAlign: "right" }}>
              <Col>
                <ButtonPermission
                  className="mr-0 btn btn-primary btn-md btn-user"
                  name="Nova Alteração de Executor"
                  permission={funcionalidades.ordemservico.inserirAltExecutor}
                  onClick={() => setMostrarTela(true)}
                />
              </Col>
            </Row>
          )}
        {(mostrarTela || dadosAltExec[0]?.situacaoAlteracaoAtual === "A") &&
          (responsabilidadeOrgao === "C" || responsabilidadeOrgao === "S") && (
            <TelaAlteraExecutorOs
              dadosOs={dadosOs}
              sqAlteracaoExecutor={
                dadosAltExec[0]?.situacaoAlteracaoAtual !== "A" ? 0 : dadosAltExec[0]?.sqAlteracaoExecutorAtual
              }
              dadosAltExec={dadosAltExec}
              sgAtividade="A1"
              limparTela={limparTela}
            />
          )}
        {!mostrarTela && dadosAltExec[0]?.situacaoAlteracaoAtual !== "A" && (
          <Row>
            <Col>
              <DataTable
                noHeader
                keyField="codigoExecutor"
                columns={columns}
                data={rows}
                progressPending={isLoading}
                noDataComponent="Não há Alterações de Executor para esta OS."
                progressComponent={<TextSpinner />}
                defaultSortFieldId={1}
                sortIcon={<BsArrowDown />}
                pagination
                sortable
                paginationTotalRows={totalRows}
                selectableRows={false}
                pointerOnHover
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                paginationComponentOptions={constants.paginationComponentOptions}
                paginationPerPage={25}
                expandableRowsHideExpander
                expandOnRowClicked
                expandableRows
                expandableRowsComponent={AlteracaoExecutorOsDetalhes}
                expandableRowsComponentProps={{ atualizarAlteracao }}
              />
            </Col>
          </Row>
        )}

        <Row>
          <Col />
        </Row>
      </div>
    </OsContext.Provider>
  );
};

export default AlteracaoExecutorOs;
